import * as React from 'react';
import { useAuth } from '../../../../App';
import { Modal, ModalBody, ModalSize, ModalFooter, CustomButton, ButtonType, CustomSubmitButton, Form, Textarea, Select } from 'soprasteria-ui-library';
import { OrthodonticReferralDecisionApi } from '../../../../api/OrthodonticReferralDecisionApi';
import { IOrthodonticReferralShareWithConsultantDentalGroup } from '../../../../models/IOrthodonticReferral';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';

interface IOrthodonticReferralSendToConsultationDentalGroupModal {
    orthodonticReferralId: number;
    changeSuccessMessage: (message: string) => void;
    getOrthodonticReferral: (id: number) => void;
    renderForm: boolean;
    setRenderForm: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OrthodonticReferralShareWithConsultationDentalGroupModal: React.FunctionComponent<IOrthodonticReferralSendToConsultationDentalGroupModal> = ({ orthodonticReferralId, changeSuccessMessage, getOrthodonticReferral, renderForm, setRenderForm }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralDecisionApi(auth);
    const [isSending, setIsSending] = React.useState<boolean>(false);
    const [orthodonticReferralAdvancedConsultationNeedReasons, setOrthodonticReferralAdvancedConsultationNeedReasons] = React.useState<IListItem[]>();

    React.useEffect(() => {
        getOrthodonticReferralAdvancedConsultationNeedReasons();
    }, [])

    const shareOrthodonticReferralWithConsultantDentalGroup = (data: IOrthodonticReferralShareWithConsultantDentalGroup) => {
        setIsSending(true);

        data.orthodonticReferralId = orthodonticReferralId;
        api.shareOrthodonticReferralWithConsultantDentalGroup(data, () => {
            document.getElementById("close-orthodontic-referral-share-with-consultation-dental-group-modal")?.click();
            changeSuccessMessage("Ortodontiremissen har skickats till urvalstandläkargruppen");
            getOrthodonticReferral(orthodonticReferralId);
        }, undefined, () => setIsSending(false));
    }

    const getOrthodonticReferralAdvancedConsultationNeedReasons = () => {
        api.getOrthodonticReferralAdvancedConsultationNeedReasons((data) => {
            const reasons = data.map<IListItem>((reason) => { return { value: reason.orthodonticReferralAdvancedConsultationNeedReasonId.toString(), text: reason.description } });
            setOrthodonticReferralAdvancedConsultationNeedReasons(reasons);
        })
    }

    return (
        <>
            <Modal header="Skicka till urvalstandläkargruppen" id="orthodontic-referral-share-with-consultation-dental-group-modal" modalSize={ModalSize.large}>
                {
                    renderForm ?
                        <Form onSubmit={shareOrthodonticReferralWithConsultantDentalGroup}>
                            <ModalBody>
                                <Select name="orthodonticReferralAdvancedConsultationNeedReasonId" options={orthodonticReferralAdvancedConsultationNeedReasons ?? []} isLoading={orthodonticReferralAdvancedConsultationNeedReasons === undefined} label="Anledning" inlineLabel required placeholder="Välj en anledning"/>
                                <Textarea name="motivation" label="Motivering" inlineLabel required rows={6} />
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} buttonText="Avbryt"
                                    data-dismiss="modal" id="close-orthodontic-referral-share-with-consultation-dental-group-modal" onClick={() => setRenderForm(false)} />
                                <CustomSubmitButton isLoading={isSending}>Skicka</CustomSubmitButton>
                            </ModalFooter>
                        </Form>
                        : null
                }
            </Modal>
        </>
    )
}